import React from 'react'

const AutomationMainPage = () => {
  return (
    <div>AutomationMainPage</div>
  )
}

export default AutomationMainPage